/*
 * nf-variant-picker.js — enhancement do seletor de sabores por tiles (Fase 4.2)
 * ----------------------------------------------------------------------------
 * Custom element <nf-variant-picker>. Puro enhancement client-side, sem framework:
 *  - busca com normalizacao de acento (NFD), filtrando os tiles por texto;
 *  - contador "N sabores" / "X de N" durante a busca;
 *  - centraliza o tile selecionado no grid ao montar (a troca de variante do
 *    product-info.js substitui o <variant-selects> inteiro e devolve o foco ao
 *    tile; como o elemento e recriado, connectedCallback re-conecta sozinho).
 *
 * Nenhuma dependencia de internals do Dawn: a selecao de variante continua sendo
 * feita pelos <input type="radio"> nativos e pelo global.js (VariantSelects).
 */
if (!customElements.get('nf-variant-picker')) {
  customElements.define(
    'nf-variant-picker',
    class NfVariantPicker extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-nf-vp-search]');
        this.grid = this.querySelector('[data-nf-vp-grid]');
        this.items = Array.from(this.querySelectorAll('[data-nf-vp-item]'));
        this.count = this.querySelector('[data-nf-vp-count]');
        this.empty = this.querySelector('[data-nf-vp-empty]');
        this.total = this.items.length;

        if (this.search) {
          this._onInput = this.filter.bind(this);
          this.search.addEventListener('input', this._onInput);
        }

        window.requestAnimationFrame(() => this.scrollSelectedIntoView());
      }

      disconnectedCallback() {
        if (this.search && this._onInput) {
          this.search.removeEventListener('input', this._onInput);
        }
      }

      static normalize(value) {
        return (value == null ? '' : String(value))
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .trim();
      }

      filter() {
        const query = NfVariantPicker.normalize(this.search.value);
        let visible = 0;

        this.items.forEach((item) => {
          const text = NfVariantPicker.normalize(item.getAttribute('data-nf-vp-text') || item.textContent);
          const match = query === '' || text.indexOf(query) !== -1;
          item.toggleAttribute('hidden', !match);
          if (match) visible += 1;
        });

        if (this.empty) this.empty.toggleAttribute('hidden', visible !== 0);

        if (this.count) {
          if (query === '') {
            this.count.textContent = `${this.total} ${this.total === 1 ? 'opção' : 'opções'}`;
          } else {
            this.count.textContent = `${visible} de ${this.total}`;
          }
        }
      }

      scrollSelectedIntoView() {
        if (!this.grid) return;
        const checked = this.querySelector('.nf-vp__radio:checked');
        const tile = checked && checked.nextElementSibling;
        if (!tile) return;

        const gridRect = this.grid.getBoundingClientRect();
        const tileRect = tile.getBoundingClientRect();
        // Rola apenas o container do grid — nunca a pagina.
        if (tileRect.top < gridRect.top || tileRect.bottom > gridRect.bottom) {
          this.grid.scrollTop = tile.offsetTop - this.grid.clientHeight / 2 + tile.clientHeight / 2;
        }
      }
    }
  );
}
